import { render } from "./RegisterModal.vue?vue&type=template&id=9af0626a"
import script from "./RegisterModal.vue?vue&type=script&lang=ts"
export * from "./RegisterModal.vue?vue&type=script&lang=ts"
script.render = render

export default script